import type { LocationQuery } from 'vue-router'
import type { RechercheQueryDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import { useRechercheDossierStore } from './useRechercheDossierStore'
import { locationQueryValueToArray, parseBool, parseIntWithDefault } from '@/features/shared/tools'
import type { PagedRequest } from '../storeRechercheBuilder'
import { provideLoadRechercheService } from '../rechercheRoutingServiceProvider'
import { buildRechercheRoutingService } from '../rechercheRoutingServiceBuilder'

export function useRechercheDossierRoutingService() {
  return buildRechercheRoutingService<RechercheQueryDTO>(useRechercheDossierStore, parseLocationQuery)
}
provideLoadRechercheService('dossier', useRechercheDossierRoutingService)

function parseLocationQuery(query: LocationQuery): PagedRequest<RechercheQueryDTO> {
  const loadParams: PagedRequest<RechercheQueryDTO> = {
    query: {
      search: locationQueryValueToArray(query.search), // à vérifier array vs string
      estSousMandatGestion: parseBool(query.estSousMandatGestion as string),
      avecSubrogation: parseBool(query.avecSubrogation as string),
      statuts: locationQueryValueToArray(query.statuts, []) as any,
      dispositifs: locationQueryValueToArray(query.dispositifs, []) as any,
      dateDebut: (query.dateDebut as string) ?? '',
      dateFin: (query.dateFin as string) ?? '',
      avecAlerteActionAFaire: parseBool(query.avecAlerteActionAFaire as string),
      estFormationInterne: parseBool(query.estFormationInterne as string),
      periode: (query.periode as string) ?? '',
    },
    orderBy: locationQueryValueToArray(query.orderBy, [])!, // verifier
    pagination: {
      pageNumber: parseIntWithDefault(query.pageNumber as string, 1)!,
      pageSize: parseIntWithDefault(query.pageSize as string) as number | undefined,
    },
  }
  return loadParams
}

